<alert [nom]="NOM_ALERTE_ERREUR_GENERALE" class="alerte" nomBouton="GLOBAL.OUI"></alert>

@if (loading) {
	<div class="spinner">
		<div class="app-spinner"></div>
	</div>
} @else {
	<div class="message-information">
		<p-message severity="info" text="{{ 'GROUPE_DE_TRAVAIL.DECLARATION_EVENEMENT.MESSAGE_PREVENTION' | translate }}"></p-message>
	</div>
	<div class="contenu-tab-groupe-de-travail">
		<div class="form-groupe-de-travail">
			<div class="input-container">
				<label for="nom-groupe-de-travail">{{ 'GROUPE_DE_TRAVAIL.LABEL_INPUT_GROUPE_DE_TRAVAIL' | translate }}</label>
				<div class="input-ajout-groupe-de-travail-button">
					<div class="input-nom-groupe-de-travail">
						<input
								type="text"
								pInputText
								id="nom-groupe-de-travail"
								[(ngModel)]="nomGroupeDeTravail"
								aria-describedby="nom-groupe-de-travail"/>
					</div>
					<div class="button-ajout-groupe-de-travail">
						<p-button [label]="'GROUPE_DE_TRAVAIL.BUTTON_AJOUTER' | translate"
								  (click)="ajouterGroupeDeTravail()"
								  [disabled]="!nomGroupeDeTravail() || !nomGroupeDeTravail().trim()"
								  [loading]="loadingAjouterGroupeDeTravail()"
						></p-button>
					</div>
				</div>
			</div>
			@if (groupesDeTravail().length > 0) {
				<div class="box-input-nom-et-checkbox-groupe-de-travail">
					@for (groupeDeTravail of groupesDeTravail(); track groupeDeTravail.id) {
						<div class="checkbox-groupe-de-travail">
							<p-checkbox [value]="groupeDeTravail" [(ngModel)]="groupesDeTravailSelectionnes"></p-checkbox>
							<div class="nom-groupe-de-travail" [ngClass]="{ 'groupe-selectionne': isGroupeSelectionne(groupeDeTravail) }"
								 (click)="selectionnerGroupePourModification(groupeDeTravail)">
								{{ groupeDeTravail.nom }}
							</div>
						</div>
					}
				</div>
				<div class="button-suppression-groupe-de-travail">
					<p-button
							[label]="'GROUPE_DE_TRAVAIL.BUTTON_SUPPRIMER' | translate"
							(click)="supprimerGroupesDeTravailConfirmation()"
							[disabled]="groupesDeTravailSelectionnes().length === 0"
							[loading]="loadingSuppressionGroupeDeTravail()"></p-button>
				</div>
			} @else {
				<div class="message-groupes-de-travail-vide">
					<span>{{ 'GROUPE_DE_TRAVAIL.AUCUN_GROUPE_DE_TRAVAIL_N_EST_ENCORE_CREER' | translate }}</span>
				</div>
			}
		</div>

		@if (groupeDeTravailAModifier()) {
			<div class="form-modification-groupe-de-travail">
				<div class="premiere-colonne">
					<div class="modifier-nom-selection-zone">
						<div class="input-container-modification">
							<label for="nom-groupe-de-travail-modification">{{ 'GROUPE_DE_TRAVAIL.LABEL_INPUT_NOM_GROUPE_DE_TRAVAIL' | translate }}</label>
							<div class="input-nom-groupe-de-travail-button">
								<div class="input-modifier-nom">
									<input
											type="text"
											pInputText
											id="nom-groupe-de-travail-modification"
											aria-describedby="nom-groupe-de-travail"
											[disabled]="!this.saisieNouveauNomGroupeDeTravail()"
											[(ngModel)]="nouveauNomGroupeDeTravail"/>
								</div>
								<div class="button-nom-groupe-de-travail">
									@if (!this.saisieNouveauNomGroupeDeTravail()) {
										<div class="button-saisir-nom-groupe-de-travail">
											<p-button
													(onClick)="activerDesactiverSaisiNomGroupeDeTravail()"
													icon="pi pi-pencil"
											></p-button>
										</div>
									} @else {
										<div class="button-valider-annuler">
											<p-button
													class="button-creer-modifier-groupe-de-travail"
													icon="pi pi-check"
													[disabled]="isButtonModifierNomGroupeDeTravailDisabled()"
													[loading]="loadingModifierUtilisateur()"
													(click)="modifierGroupeDeTravail()"
											></p-button>

											<p-button
													(onClick)="activerDesactiverSaisiNomGroupeDeTravail()"
													icon="pi pi-times"
											></p-button>
										</div>
									}
								</div>
							</div>
						</div>
					</div>
					<div class="container-zones-autorisees">
						<app-gestion-zones-autorisees [zonesAutorisees]="groupeDeTravailAModifier().zonesDeTravailAutorisees" (onAjoutRetraitZonesAutorisees)="onAjoutRetraitZones($event)"/>
					</div>
				</div>
				<div>
				<app-ajout-utilisateur
						[typeEntity]="'groupeDeTravail'"
						[entityGestionEquipe]="groupeDeTravailAModifier()"
						[(utilisateurAAjouter)]="utilisateurAAjouter"
						(utilisateursTrouves)="utilisateursSuggestions = $event"
						[labelBouttonAjouter]="'GROUPE_DE_TRAVAIL.BUTTON_AJOUTER' | translate"
						[tailleScrollTable]="400"
						(ajouterUtilisateur)="ajouterUtilisateur()"
						(retirerUtilisateurs)="retirerUtilisateurs()"
						[(utilisateursSelectionnes)]="utilisateursSelectionnes"/>
				</div>
			</div>
		}
	</div>
	<confirmation-modal-component #confirmationModalComponent></confirmation-modal-component>
}
